module.exports = __webpack_public_path__ + "img/logo_26.80470982.png";